import { render, staticRenderFns } from "./CustomReport.vue?vue&type=template&id=4312c8ac&scoped=true&"
import script from "./CustomReport.vue?vue&type=script&lang=js&"
export * from "./CustomReport.vue?vue&type=script&lang=js&"
import style0 from "./CustomReport.vue?vue&type=style&index=0&id=4312c8ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4312c8ac",
  null
  
)

export default component.exports